export default [
    {
        k: 'PUE',
        v: 'Pago en una sola exhibición'
    },
    {
        k: 'PPD',
        v: 'Pago en parcialidades o diferido'
    }
    ]